import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';
import BasicSettings from './BasicSettings';
import ClientConfigSettings from './ClientConfigSettings';
import SimulateBotStoreConfig from './SimulateBotStoreConfig';

class AppStoreTabSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/bot-store";
            var path1 = window.origin + "/platform/projectmgmt/bot-store/";
            if (currentPath === path || currentPath === path1) {
                $("#store-basic-settings").addClass('active');
            } else if (currentPath.includes("/projectmgmt/bot-store/client-config-settings")) {
                $("#store-client-settings").addClass('active');
            } else if (currentPath.includes("/projectmgmt/bot-store/botstore-demo-config")) {
                $("#botstore-demo-config").addClass('active');
            } $("#store-basic-settings,#store-client-settings,#botstore-demo-config")
                .on("click", function () {
                    $("#store-basic-settings,#store-client-settings,#botstore-demo-config")
                        .removeClass('active');
                    $(this).addClass('active')

                })
        })();

    }

    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />


                    <h6 className="nav-item" style={{
                        color: '#282a65',
                        marginLeft: '8px'
                    }} >Sell your agents on Dhee store</h6>
                    <div className="container-fluid" style={{ marginLeft: '6px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '-6px' }}>
                            <ul className="nav nav-tabs border-bottom navCluster">
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/bot-store" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="store-basic-settings" >
                                        Basic Settings
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/bot-store/client-config-settings" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="store-client-settings" >
                                        Client-Configurable Settings
                                    </li>
                                </Link>
                                <Link to="/projectmgmt/bot-store/botstore-demo-config" style={{ textDecoration: 'none' }}>
                                    <li className="nav-item nav-link" id="botstore-demo-config">
                                        BotStore Demo Configuration</li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/bot-store/botstore-demo-config" component={SimulateBotStoreConfig}></Route>
                    <Route path="/projectmgmt/bot-store/client-config-settings" component={ClientConfigSettings}></Route>
                    <Route path="/projectmgmt/bot-store" component={BasicSettings}></Route>
                </Switch>
            </div>

        );
    }
}
export default AppStoreTabSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/appStore/AppStoreTabSetting.js